<template>
  <el-dialog :visible.sync="dialogVisible" @open="dialogOpen">
    <div slot="title">维护
      <el-tag>{{role.roleName}}</el-tag>权限</div>
    <el-input size="mini" placeholder="输入关键字进行过滤" v-model="filterText" style="padding-bottom: 5px;"></el-input>
    <el-tree ref="tree" show-checkbox check-on-click-node default-expand-all :props="{label: 'title'}" highlight-current node-key="id" :data="permissionList" :filter-node-method="filterNode" :expand-on-click-node="false">
      <span slot-scope="{ node, data }">
        <i v-if="data.type==2" class="fa fa-cog"></i>&nbsp;{{ node.label }}
      </span>
    </el-tree>
    <div slot="footer" class="dialog-footer"   v-if="formEdit">
      <el-button type="primary" :loading="loading" @click="saveRolePermission">保存</el-button>
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>

</template>
<script>
import * as roleService from '@/api/sys/role'
import * as menuService from '@/api/sys/menu'
import util from '@/libs/util.js'
export default {
  name: 'rolePermission',
  props: {
    role: Object,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      loading: false,
      dialogVisible: false,
      filterText: '',
      permissionList: []
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    },
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    async dialogOpen () {
      console.log('==============')

      const uuid = util.cookies.get('uuid')
      let permissionList2 = await menuService.getMenuList({ uuid: uuid, roleId: this.role.roleId, agentid: util.cookies.get('agentid') })
      if (util.cookies.get('agentid') != null && util.cookies.get('agentid') != '') {
        68, 69, 70, 71
        if (this.role.roleId == 68 || this.role.roleId == 69 || this.role.roleId == 70 || this.role.roleId == 71) {
          this.formEdit = false
        } else {
          this.formEdit = true
        }
      } else {
        this.formEdit = true
      }
      this.permissionList = permissionList2.accessMenus
      let rolePermissions = permissionList2.accessRoutes// await roleService.getRolePermissions({roleId:this.role.roleId});
      let rolePermissionList = rolePermissions.map(s => s.menuId)
      let kkkkk = []
      this.$refs.tree.setCheckedKeys(kkkkk)
      this.$refs.tree.setCheckedKeys(rolePermissionList)
    },
    filterNode (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    saveRolePermission () {
    //  let checkedNodes = this.$refs.tree.getCheckedNodes(true, false);
      let checkedPermissins = [].concat(
        this.$refs.tree.getHalfCheckedKeys(),
        this.$refs.tree.getCheckedKeys()
      )
      console.log('=========checkedNodes:' + checkedPermissins)
      /** let checkedPermissins = [];
      for (let checked of checkedNodes) {
          checkedPermissins.push(checked.id);
      }**/
      let data = {
        roleId: this.role.roleId,
        permissions: checkedPermissins
      }
      this.loading = true
      roleService.savePermission(data).then(data => {
        this.loading = false
        this.dialogVisible = false
      })
    },
    close () {
      this.dialogVisible = false
    }
  }
}
</script>
